const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export function fmtDate(str) {
  if (!str) return '—';
  const datePart = String(str).slice(0, 10);
  if (datePart === '0000-00-00') return '—';
  const [y, m, d] = datePart.split('-');
  if (!y || !m || !d) return str;
  const mn = parseInt(m, 10);
  const dn = parseInt(d, 10);
  if (!mn || !dn || mn < 1 || mn > 12) return '—';
  return `${dn} ${MONTHS[mn - 1]} ${y}`;
}
